import axiosInstance from "services/AxiosInstance";
import { TBuyspacesListResponse, TBuyspacesRequestParams } from "types";

export const getBuyspacesService = async (params: TBuyspacesRequestParams): Promise<TBuyspacesListResponse> => {
  const { id, ...restParams } = params;
  const response = await axiosInstance.get(`/buyspace/account/${params.id}`, { params: restParams });
  return response.data;
};
